import { Box, Tooltip } from "@mui/material";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import GpsOffIcon from "@mui/icons-material/GpsOff";

/**
 * Compact icon indicator for lasered deductibles.
 * Used across Summary Table, Watch List, Claimant List, and export views.
 */
export const LaseredDeductibleChip = ({ compact: _compact = true }: { compact?: boolean }) => (
  <Tooltip title="Lasered deductible applied" arrow>
    <Box component="span" display="inline-flex" alignItems="center">
      <GpsFixedIcon sx={{ fontSize: 15, color: "primary.main" }} />
    </Box>
  </Tooltip>
);

/**
 * Compact icon indicator for contract-laser deductibles (Feature #5287).
 * Distinct color from the straight-laser indicator.
 */
export const ContractLaserDeductibleChip = ({ compact: _compact = true }: { compact?: boolean }) => (
  <Tooltip title="Contract laser applied" arrow>
    <Box component="span" display="inline-flex" alignItems="center">
      <GpsFixedIcon sx={{ fontSize: 15, color: "secondary.main" }} />
    </Box>
  </Tooltip>
);

/**
 * Compact icon indicator for full contract exclusion (Feature #5287).
 */
export const ContractExcludedChip = ({ compact: _compact = true }: { compact?: boolean }) => (
  <Tooltip title="Excluded from contract" arrow>
    <Box component="span" display="inline-flex" alignItems="center">
      <GpsOffIcon sx={{ fontSize: 15, color: "error.main" }} />
    </Box>
  </Tooltip>
);
